const setScrollbarWidth = () => {
  const updateScrollBarWidth = () => {
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`);
  };

  // debounce関数
  const debounce = function (callback) {
    let timeout;

    return function () {
      const args = arguments; // 引数を保持
      const context = this;  // コンテキストを保持

      if (timeout !== undefined) cancelAnimationFrame(timeout);
      timeout = requestAnimationFrame(function () {
        callback.apply(context, args);
      });
    };
  };

  window.addEventListener('resize', debounce(updateScrollBarWidth));
  window.addEventListener('load', updateScrollBarWidth);
};

export default setScrollbarWidth;
